/**
 * A saved quiz's report, reopened from My Progress: the same topic breakdown,
 * AI review and per-question list the learner saw when they finished it.
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api/client";
import { QuizReviewList } from "./QuizReviewList";
import { QuizTopicSummary } from "./QuizTopicSummary";
import type { SavedQuizResult } from "../types";

export function SavedQuizReport({ resultId }: { resultId: string }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["quiz-result", resultId],
    queryFn: () => apiGet<SavedQuizResult>(`/api/quiz/results/${resultId}`),
  });
  if (isLoading) return <p className="text-muted">Loading the report…</p>;
  if (error || !data) return <p className="error-message">Couldn't load this quiz report.</p>;
  return (
    <div className="saved-quiz-report">
      <QuizTopicSummary
        topics={data.topics}
        aiReview={data.ai_review}
        aiState={data.ai_review ? "ready" : "off"}
      />
      <QuizReviewList items={data.answers} />
    </div>
  );
}
